import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1235941874/src/CVCircuit/frontend/app/blog/[slug]/BlogPostPageClient.tsx");
